// src/components/FormInput.js
import React from 'react';
import { Form } from 'react-bootstrap';

function FormInput({ label, type, name, register, validation, error }) {
    return (
      <Form.Group controlId={name}>
        <Form.Label>{label}</Form.Label>
        <Form.Control
          type={type}
          {...register(name, validation)}
          isInvalid={!!error}
        />
        {error && <Form.Control.Feedback type="invalid">
          {error.message}
        </Form.Control.Feedback>}
      </Form.Group>
    );
  }
export default FormInput;
